import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { WorkRequestJobHazardAssessmentStatus } from '@acceligentllc/shared/enums/workRequestJobHazardAssessmentStatus';

import type { RootState } from 'af-reducers';

import { SegmentLabel } from '@acceligentllc/storybook';

import RadioGroup from 'af-fields/RadioGroup';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn8, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

const JOB_HAZARD_ASSESSMENT_OPTIONS = Object.keys(WorkRequestJobHazardAssessmentStatus)
	.map((_dm) => {
		switch (_dm) {
			case (WorkRequestJobHazardAssessmentStatus.COMPLETE): {
				return { value: _dm, label: 'Complete' };
			}

			case (WorkRequestJobHazardAssessmentStatus.IN_PROGRESS): {
				return { value: _dm, label: 'In Progress' };
			}

			case (WorkRequestJobHazardAssessmentStatus.NOT_STARTED): {
				return { value: _dm, label: 'Not Started' };
			}

			default: {
				return { value: _dm, label: 'Not Started' };
			}
		}
	});

type OwnProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	change: (fieldName: string, value: any) => void;
	formName: string;
	isDisabled: boolean;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const StatusSection: React.FC<Props> = (props) => {
	const { change, jobHazardAssessmentStatus, isDisabled } = props;

	const onDisposalMethodChange = React.useCallback((field: string, value) => {
		change(field, value);
	}, [change]);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Status"
				tooltip="The current progress state of this job record, indicating whether the job is pending, actively in progress, or completed."
			/>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					{!jobHazardAssessmentStatus && (
						<div className={styles['job-form__job-hazard-assessment-status-error']}>
							Please select current status of the Job Hazard Assessment Form.
						</div>
					)}
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={formSectionClassColumn8}>
					<RadioGroup
						changeField={onDisposalMethodChange}
						disabled={isDisabled}
						extraClass={styles['job-form__radio-group']}
						field={JobUpsertFM.getAttributeName('jobHazardAssessmentStatus')}
						inline={true}
						items={JOB_HAZARD_ASSESSMENT_OPTIONS}
					/>
				</div>
			</div>
		</div>
	);
};

function mapStateToProps(state: RootState, props: OwnProps) {
	const selector = formValueSelector(props.formName);

	const jobHazardAssessmentStatus = selector(
		state,
		JobUpsertFM.getAttributeName('jobHazardAssessmentStatus')
	);

	return {
		jobHazardAssessmentStatus,
	};
}

const connector = connect(mapStateToProps);

export default connector(StatusSection);
